module.exports = __webpack_public_path__ + "static/img/courseGh.4ee599a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/courselist/courseGh.png
// module id = sQCx
// module chunks = 23